<div class="text {$$props.class ?? ''}">
  <slot />
</div>
